<template>
  <div class="justify-content-center row no-gutters mobileAuthForm">

    <div class="col-12">
      <img
        src="./../../assets/logo.png"
        title="BestUse"
        id="logo"
        alt="BestUse"
        class="col-md-3 col-lg-2"
      />
    </div>

    <div class="col-md-8 col-lg-4 col-xl-3 mt-5">
      <recupera-senha-form standalone />
    </div>

    <div class="row linksPoliticas fixed-bottom border-top ">
      <div class="mt-2 mb-2 col">
        <div class="row">
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/politicaPrivacidade.php" title="Clique para acessar">
            Política de privacidade
          </a>
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/politicaReembolso.php" title="Clique para acessar">
            Política de reembolso
          </a>
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/termos.php" title="Clique para acessar">
            Termos de serviço
          </a>
          <div class="col-12 text-center">
            <small>
              © 2019 - BestUse - CNPJ: 11.195.812/0001-56 - Todos os direitos reservados
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecuperaSenhaForm from './recuperaSenhaForm.vue';

export default {
  name: 'ResetSenha',
  components: {
    RecuperaSenhaForm,
  },
};
</script>

<style>
.linksPoliticas a {
  font-size: 12px;
  color: #fff !important;
  background-color: #20242e;
}

.btn-default {
  color: #fff;
}

.btn-default:hover {
  color: #d90f30;
}
</style>
